<div id="overlay-pop-table" [ngStyle]="{position:'absolute'}" [style.display]="(isLoading ? 'block' : 'none' )">
    <div class="overlay-message"></div>
</div>
<div id="table-orders" (scroll)="checkScroll()" class="main-table-container mat-elevation-z1"
    style="position: relative;padding:0px" [ngStyle]="$safeNavigationMigration(tabelConfig?.style)">
    <div *ngIf="serverError" tabindex="-1" id="error" class="error-message">{{serverError}}</div>
    <table mat-table [dataSource]="dataSource" matSort>
        <ng-container *ngIf="tabelConfig.TableHeaders">
            <ng-container style="position: relative;" *ngFor="let data of tabelConfig.TableHeaders; let i= index;"
                [matColumnDef]="data.title">
                <!-- Defining checkbox column head & cell -->
                <ng-container matColumnDef="select" *ngIf="i === 0 && tabelConfig.rowOptions">
                    <span *ngIf="tabelConfig.rowOptions.mutipleRowOperation">
                        <th mat-header-cell *matHeaderCellDef>
                            <ng-container *ngIf="data.type === 'checkbox';else iconRows">
                                <mat-checkbox [disabled]="data.disabled" #rowCheckbox
                                    (change)="$event ? masterToggle() : null"
                                    [checked]="selection.hasValue() && isAllSelected()"
                                    [indeterminate]="selection.hasValue() && !isAllSelected()"
                                    [aria-label]="checkboxLabel()">
                                </mat-checkbox>
                            </ng-container>
                            <ng-template #iconRows>
                                <label>{{data.title}}</label>
                            </ng-template>
                        </th>
                        <td mat-cell *matCellDef="let row">
                            <ng-container *ngIf="data.type === 'checkbox';else iconcols">
                                <mat-checkbox #colCheckbox [disabled]="data.disabled" (click)="$event.stopPropagation()"
                                    (change)="$event ? selection.toggle(row) : null"
                                    [checked]="selection.isSelected(row)" [aria-label]="checkboxLabel(row)">
                                </mat-checkbox>
                            </ng-container>
                            <ng-template #iconcols>
                                <mat-icon color="primary"
                                    (click)="toggleSearchPreference($event, row, tabelConfig.rowOptions)">
                                    {{ ( isRowSelected(row) ? 'star' : 'star_outline' )}}
                                </mat-icon>
                            </ng-template>
                        </td>
                    </span>
                </ng-container>

                <th mat-header-cell mat-sort-header *matHeaderCellDef [ngStyle]="{'max-width.px': data.width}">
                    {{data.title}}
                </th>
                <td mat-cell *matCellDef="let element" [ngStyle]="{'max-width.px': data.width}">
                    <span *ngIf="i === tabelConfig.TableHeaders.length-1">
                        <span *ngIf="tabelConfig.rowOptions && tabelConfig.rowOptions.rowMenu"
                            style="position: absolute;right: 0;">
                            <button mat-button mat-icon-button matTooltip="Menu" [matMenuTriggerFor]="menu"
                                aria-label="Example icon-button with a menu">
                                <mat-icon>more_vert</mat-icon>
                            </button>
                            <mat-menu #menu="matMenu" overlapTrigger>
                                <ng-container *ngIf="tabelConfig.rowOptions">
                                    <ng-container *ngIf="tabelConfig.rowOptions.rowMenuOption">
                                        <button mat-menu-item color="accent"
                                            *ngFor="let action of tabelConfig.rowOptions.rowMenuOption"
                                            (click)="performAction($event, action.name, element, action, null)">

                                            <mat-icon *ngIf="action.icon" class="fa" style="cursor:pointer"
                                                matTooltip="{{action.toolTip}}">
                                                {{action.icon}}
                                            </mat-icon>
                                            <span> {{action.label}}</span>
                                        </button>
                                    </ng-container>
                                </ng-container>
                            </mat-menu>
                        </span>
                        <span *ngIf="tabelConfig.actions" class="action-icons">
                            <span *ngFor="let action of tabelConfig.actions">
                                <button type="button" mat-button mat-icon-button color="accent"
                                    (click)="performAction($event, action.name, element, action, null)">
                                    <mat-icon class="fa" style="cursor:pointer" matTooltip="{{action.toolTip}}">
                                        {{action.icon}}
                                    </mat-icon>
                                </button>
                            </span>
                        </span>
                    </span>
                    <span>
                        <span *ngIf="data.primaryText">
                            {{element[data.primaryText.key]}}
                        </span>
                        <br>
                        <span *ngIf="data.secondaryText" class="cell-secondary-value">
                            {{element[data.secondaryText.key]}}
                        </span>
                    </span>
                </td>

            </ng-container>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="newDisplayedColumns; sticky: true"></tr>
        <tr mat-row (click)="onRowClickHandler(row, tabelConfig.rowOptions)" class="data-row"
            *matRowDef="let row; columns: newDisplayedColumns;"> </tr>
    </table>
</div>

<app-progress-spinner-v2 *ngIf="isLoading"></app-progress-spinner-v2>